import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../../components/Checkbox/Checkbox';
import { downloadFile, formatNumber } from '../../../core/helpers';
import './InvoiceBookResults.scss';
import data from './data.json';
import classNames from 'classnames';
import { ReactComponent as DownloadIcon } from '../../../icons/download.svg';
import Button from '../../../components/Button';

// const options = [
//   {
//     id: 'SKR03',
//     name: 'SKR03',
//   },
//   {
//     id: 'SKR04',
//     name: 'SKR04',
//   },
//   {
//     id: 'Custom',
//     name: 'Custom',
//   },
// ];

const PAGE_SIZE = 30;

export default function InvoiceBookResults() {
  const [isOSSIncluded, setIsOSSIncluded] = useState(true);
  // const [kontoFormat, setKontoFormat] = useState('');
  const [curPage, setCurPage] = useState(1);

  const { t } = useTranslation();

  const header = Object.keys(data[0])
    .sort((a: string, b: string) => sortData(a, b))
    .map((k) => {
      if (k === 'Dokumentennummer') return 'DokumentenNr.';
      return k;
    });

  const pages = Math.ceil(data.length / PAGE_SIZE);

  const onClickPage = (i: number) => () => {
    setCurPage(i);
  };

  const renderPagination = () => {
    const pageLabels = Array(pages)
      .fill(1)
      .map((_, i) => i + 1);

    // #TODO 1 2 3 ... 17 18 19
    // if (pageLabels.length > 6 && pageLabels.length - curPage < 5) {
    //   return <></>;
    // }

    return (
      <div className='row row-cols-auto gx-3'>
        {pageLabels.map((p) => (
          <div className='col' key={p}>
            <button
              className={classNames(
                'p-0 border-0 bg-transparent InvoiceBookResults__btn transition-color',
                {
                  'Text--gray': p !== curPage,
                }
              )}
              onClick={onClickPage(p)}
            >
              {p}
            </button>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className='InvoiceBookResults'>
      <div className='d-flex align-items-center justify-content-between mb-3'>
        <div className='Text--20 fw-800'>
          {formatNumber(1030)} {t('transactions')}
        </div>
        <div className='row row-cols-auto gx-3'>
          <div className='col'>
            <span className='fw-600 me-2'>{t('Total Net')}</span>
            <span>
              {formatNumber(10000, {
                currency: 'eur',
              })}
            </span>
          </div>
          <div className='col'>
            <span className='fw-600 me-2'>{t('Total Gross')}</span>
            <span>
              {formatNumber(15230, {
                currency: 'eur',
              })}
            </span>
          </div>
          <div className='col'>
            <span className='fw-600 me-2'>{t('Total VAT')}</span>
            <span>
              {formatNumber(5320, {
                currency: 'eur',
              })}
            </span>
          </div>
        </div>
      </div>
      <div className='d-flex align-items-center justify-content-between mb-3'>
        <div className='d-flex align-items-center'>
          {/* <div className='fw-600 me-2'>Konto format</div>
          <Select
            name='arrival_country'
            placeholder='Select'
            options={options}
            value={kontoFormat}
            onChange={(id: string | number) => {
              setKontoFormat(id as string);
            }}
            className='Select--InvoiceBookResults me-2 pb-0'
          /> */}
          <Checkbox
            checked={isOSSIncluded}
            onChange={(e) => {
              setIsOSSIncluded(e.target.checked);
            }}
            className='Checkbox--InvoiceBookResults d-flex align-items-center'
          >
            {t('Include OSS')}
          </Checkbox>
        </div>
        <div>
          <Button
            styling='outline'
            className='py-2 ps-2 pe-3 d-inline-flex align-items-center'
            onClick={() => {
              downloadFile(
                '/Rechnungsausgangsbuch-abc-gmbh-3288.xlsx',
                'Rechnungsausgangsbuch-abc-gmbh-3288.xlsx'
              );
            }}
          >
            <DownloadIcon className='SellerManualUploadInstructionBlock__download me-2' />
            {t('Download XLSX')}
          </Button>
        </div>
      </div>
      <div
        className='table-responsive Scrollbar border'
        style={{
          borderRadius: 8,
        }}
      >
        <table className='table InvoiceBookResults__table'>
          <thead>
            <tr>
              {header.map((h) => (
                <td key={h} className='text-nowrap Text--gray border-0'>
                  {h}
                </td>
              ))}
            </tr>
          </thead>
          <tbody className='border-0'>
            {data
              .slice((curPage - 1) * PAGE_SIZE, curPage * PAGE_SIZE)
              .map((d, i) => (
                <tr key={i}>
                  {Object.entries(d)
                    .sort(
                      (
                        a: [string, string | number | null],
                        b: [string, string | number | null]
                      ) => sortData(a[0], b[0])
                    )
                    .map(([_, v], i) => {
                      return (
                        <td key={i} className='text-nowrap border-0 Text--dark'>
                          {v}
                        </td>
                      );
                    })}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className='d-flex justify-content-center pt-4'>
        {curPage > 1 && (
          <button
            className='pt-0 border-0 bg-transparent Text--gray me-4 InvoiceBookResults__btn transition-color'
            onClick={() => {
              setCurPage((p) => p - 1);
            }}
          >
            {t('Back')}
          </button>
        )}
        {renderPagination()}
        {curPage < pages && (
          <button
            className='pt-0 border-0 bg-transparent Text--gray ms-4 InvoiceBookResults__btn transition-color'
            onClick={() => {
              setCurPage((p) => p + 1);
            }}
          >
            {t('Forward')}
          </button>
        )}
      </div>
    </div>
  );
}

const sortData = (a: string, b: string) => {
  if (
    !['Typ', 'Dokumentennummer', 'Dokumentendatum'].includes(b) &&
    a === 'Konto'
  ) {
    return -1;
  }
  if (
    !['Typ', 'Dokumentennummer', 'Dokumentendatum', 'Konto'].includes(b) &&
    a === 'Gegenkonto'
  ) {
    return -1;
  }
  if (
    ![
      'Typ',
      'Dokumentennummer',
      'Dokumentendatum',
      'Konto',
      'Gegenkonto',
    ].includes(b) &&
    a === 'Channel'
  ) {
    return -1;
  }

  return 0;
};
